module.exports = __webpack_public_path__ + "media/app/images/stripe_payment@2x-254ff03157318bbd5c6bfce4a6546200.png";